module.exports = __webpack_public_path__ + "static/media/sample_drivers_vic.b189e668.jpg";